import { render, staticRenderFns } from "./buyCenter.vue?vue&type=template&id=086e6b51&scoped=true&"
import script from "./buyCenter.vue?vue&type=script&lang=js&"
export * from "./buyCenter.vue?vue&type=script&lang=js&"
import style0 from "./buyCenter.vue?vue&type=style&index=0&id=086e6b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086e6b51",
  null
  
)

export default component.exports